import React from "react";
import cn from "classnames";
import styles from "./index.module.scss";
interface SpinProps {
  loading: boolean;
  children?: React.ReactNode;
}

// TODO: 暂无包裹需求
export default function Spin({ loading, children }: SpinProps) {
  return (
    <div>
      {children}
      <svg
        className={cn(styles.spinner, loading ? "" : styles.hidden)}
        viewBox="0 0 50 50"
      >
        <circle
          className={styles.path}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
        ></circle>
      </svg>
    </div>
  );
}
